import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

export const ScoreCardMisconfig = ({ title, data, totalMisconfig, criticalMisconfig, warningMisconfig }) => {
  const COLORS = ['#ff4d4f', '#faad14', '#52c41a', '#1890ff'];

  return (
    <div className="mb-3">
      <div
        className="card p-4 rounded-4 shadow-sm text-white border-0"
        style={{ backgroundColor: '#343a40', width: 360 }}
      >
        <div className="d-flex flex-column justify-content-between h-100">
          {/* Header with Title & Small Pie Chart */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="mb-0">{title}</h4>
            <div style={{ width: 60, height: 60 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={15}
                    outerRadius={25}
                    paddingAngle={2}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: '#222',
                      border: 'none',
                      color: '#fff',
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Score Info */}
          <div className="pt-2">
            <div className="d-flex justify-content-between">
              <span className="fw-light">Total</span>
              <span className="fw-semibold">{totalMisconfig}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-light">Critical</span>
              <span className="fw-semibold">{criticalMisconfig}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-light">Warning</span>
              <span className="fw-semibold">{warningMisconfig}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};